/**
 * NotesField - Notes textarea field
 *
 * Fields: notes
 */

import type { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'
import type { AircraftFormValues } from '../aircraft-form-schema'

interface NotesFieldProps {
  form: UseFormReturn<AircraftFormValues>
  disabled?: boolean
  /** Show description text */
  showDescription?: boolean
  /** Show label */
  showLabel?: boolean
}

export function NotesField({
  form,
  disabled = false,
  showDescription = true,
  showLabel = true,
}: NotesFieldProps) {
  return (
    <FormField
      control={form.control}
      name="notes"
      render={({ field }) => (
        <FormItem>
          {showLabel && <FormLabel>Staff Notes</FormLabel>}
          <FormControl>
            <Textarea
              {...field}
              value={field.value ?? ''}
              onChange={(e) => field.onChange(e.target.value || null)}
              placeholder="Additional notes about this aircraft..."
              rows={4}
              className="resize-none"
              disabled={disabled}
            />
          </FormControl>
          {showDescription && (
            <FormDescription>Internal notes visible to staff only.</FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
